// extracted by mini-css-extract-plugin
export var wrapper = "MainSlider-module--wrapper--15N5s";
export var sliderItem = "MainSlider-module--slider-item--WWWBg";
export var slickDots = "MainSlider-module--slick-dots--NXKxv";